<template>
  <div class="zj-search-result-table">
    <div class="zj-dropdown-fields">
      <ComponentDropdown
        syscode="EmergencyService"
        ukey="communication_type"
        placeholder="通信资源类别"
        v-on:onSelectChange="onCommunicationResourcesTypeSelectChange"
      ></ComponentDropdown>
    </div>
    <el-table :data="tableData" @row-click="rowclick" :show-header="false">
      <el-table-column>
        <template slot-scope="scope">
          <ComponentInfoPanel
            type="Communicationresources"
            v-bind:info="convert(scope.$index,scope.row)"
          ></ComponentInfoPanel>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { list } from "@/api/src/emergency_communication";
import ComponentDropdown from "./Component-Dropdown";
import ComponentInfoPanel from "./Component-InfoPanel";

export default {
  components: {
    ComponentDropdown: ComponentDropdown,
    ComponentInfoPanel: ComponentInfoPanel
  },
  props: {
    targetUri: Object,
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    },
    searchText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      CommunicationResourcesType: null,
      selectData: null
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    convert(index, row) {
      var result = {
        index:(this.pageSize *(this.currentPage - 1)) + index + 1,
        ...row,
      };
      return result;
    },
    search() {
      let searchInfo = {
        name: this.searchText,
        longitude: this.center[0] || 0,
        latitude: this.center[1] || 0,
        size: this.pageSize,
        current: this.currentPage,
        communicationType: this.CommunicationResourcesType,
      };
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
        })
        .catch(e => {
          console.log(e);
        });
    },
    // eslint-disable-next-line no-unused-vars
    rowclick(row, column, e) {
      // 给分发事件
      this.dispatch("ZjEmergencyOneMap", "poiselected", row.id);
      this.dispatch("ZjEmergencyOperations", "poiselected", row.id);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onCommunicationResourcesTypeSelectChange(val) {
      this.CommunicationResourcesType = val;
      this.search();
    }
  },
  watch: {
    center: function() {
      this.search();
    },
    searchText: function() {
      this.search();
    }
  }
};
</script>